export const ComercialformItems = [
    {
        label: 'nome',
        inputName: 'name',
        typeInput: 'text',
        placeholder: 'Ex: João',
    },
    {
        label: 'sobrenome',
        inputName: 'last_name',
        typeInput: 'text',
        placeholder: 'Ex: Santos',
    },
    {
        label: 'email corporativo',
        inputName: 'email',
        typeInput: 'text',
        placeholder: 'Ex: exemplo@gmail.com',
    },
    {
        label: 'telefone',
        inputName: 'phone',
        typeInput: 'tel',
        placeholder: 'Ex: +55 21 91234-5678',
        // HTML pattern como string:
        pattern: /^\+?\d{10,15}$/,
        maxLength: 16, // opcional, ajuda UX
    },
    //   -------------------- OLD ------------------
    // {
    //     label: 'telefone',
    //     inputName: 'phone',
    //     typeInput: 'tel',
    //     placeholder: 'Ex: 21 91234-5678',
    //     pattern: /\d{10,11}/,
    // },
    {
        label: 'nome da empresa',
        inputName: 'company_name',
        typeInput: 'text',
        placeholder: 'Digite o nome da empresa',
    },
    {
        label: 'CNPJ',
        inputName: 'cnpj',
        typeInput: 'text',
        placeholder: 'Ex: 04522176000164 ou 04.522.176/0001-64',
    },
    {
        label: 'departamento de atuação',
        inputName: 'department',
        typeInput: 'text',
        placeholder: 'Digite o seu departamento de atuação',
    },
    {
        label: 'assunto',
        inputName: 'subject',
        typeInput: 'text',
        placeholder: 'Ex: Orçamento Cloud',
    },
    {
        label: 'mensagem',
        inputName: 'message',
        isTextArea: true,
        placeholder: 'Digite sua mensagem',
    },
];

export const SacFormItems = {
    InputForm: [
        {
            label: 'nome',
            inputName: 'name',
            typeInput: 'text',
            placeholder: 'Ex: João',
        },
        {
            label: 'sobrenome',
            inputName: 'last_name',
            typeInput: 'text',
            placeholder: 'Ex: Santos',
        },
        {
            label: 'email',
            inputName: 'email',
            typeInput: 'text',
            placeholder: 'Ex: exemplo@gmail.com',
        },
        {
            label: 'telefone',
            inputName: 'phone',
            typeInput: 'tel',
            placeholder: 'Ex: +55 21 91234-5678',
            pattern: /^\+?\d{10,15}$/,
            maxLength: 16,
        },
        // -----------------OLD---------------
        // {
        //     label: 'telefone',
        //     inputName: 'phone',
        //     typeInput: 'tel',
        //     placeholder: 'Ex: 21 91234-5678',
        //     pattern: /\d{10,11}/,
        // },
        {
            label: 'Título da Mensagem',
            inputName: 'title',
            typeInput: 'text',
            placeholder: 'Ex: Suporte Cloud',
        },
    ],
    SelectForm: {
        label: 'Assunto',
        nameInput: 'category',
        optionValues: [
            { label: 'Sugestão', value: 'sugestao' },
            { label: 'Elogios', value: 'elogios' },
            { label: 'Reclamação', value: 'reclamacao' },
            { label: 'Suporte', value: 'suporte' },
        ],
    },
    TextArea: {
        label: 'mensagem',
        inputName: 'message',
        isTextArea: true,
        placeholder: 'Digite sua mensagem',
    },
};
